import { render, staticRenderFns } from "./BackNav.vue?vue&type=template&id=56e19038"
import script from "./BackNav.vue?vue&type=script&lang=js"
export * from "./BackNav.vue?vue&type=script&lang=js"
import style0 from "./BackNav.vue?vue&type=style&index=0&id=56e19038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports